const state = {
  userInfo: {
    nickname:'',
    avatar: '',
    id: '',
    email: '',
    role: '',
    createTime: '',
    updateTime: '',
    isLogin: false
  },
  userArticles: {
    recent: [],
    article: [],
    category: []
  },
  userCategories: [],
  currentTab: 'recent'
}

const mutations = {
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  SET_USER_ARTICLES(state, { type, articles }) {
    state.userArticles[type] = articles
  },
  SET_USER_CATEGORIES(state, categories) {
    state.userCategories = categories
  },
  SET_CURRENT_TAB(state, tab) {
    state.currentTab = tab
  }
}

const actions = {
  setUserInfo({ commit }, info) {
    commit('SET_USER_INFO', info)
  },
  setUserArticles({ commit }, { type, articles }) {
    commit('SET_USER_ARTICLES', { type, articles })
  },
  setUserCategories({ commit }, categories) {
    commit('SET_USER_CATEGORIES', categories)
  },
  setCurrentTab({ commit }, tab) {
    commit('SET_CURRENT_TAB', tab)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
} 